<template>
  <a-card :bordered="false" style="width: 130%;text-align: center;margin-left:-10%">
    123
  </a-card>
</template>

<script>

  export default {
    name: "userApply",
    components: {
    },
    data() {
      return {
        description: '将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。',
        currentTab: 0,
        userList: {},
        // form
        form: null,
      }
    },
    methods: {

    },
  }
</script>

<style lang="less" scoped>
</style>

